























import { QuestionData, ReportContext, ReportNode } from '@/utils/ReportUtils';
import SurveyNodeUtils from '@/utils/SurveyNodeUtils';
import mixins from 'vue-typed-mixins';
export default mixins().extend({
  props: {
    context: {
      type: Object as () => ReportContext,
    },
    node: {
      type: Object as () => ReportNode,
    },
  },

  computed: {
    dirty() {
      return this.node.children?.some(
        (node) => node.type === 'question' && (node.data as QuestionData).dirty
      );
    },

    navigation() {
      const reducer = (result: ReportNode[], current: ReportNode) => {
        if (current.type === 'page') {
          // TODO: support more node types than just page? section toc?
          result.push(current);
        }
        if (current.children?.length > 0) {
          current.children.reduce(reducer, result);
        }
        return result;
      };

      const nodes = this.context.nodes?.reduce(reducer, []) || [];
      const index = nodes.findIndex((node) => node?.uuid === this.node?.uuid);

      const navigation: {
        previous?: ReportNode;
        next?: ReportNode;
      } = {
        previous: undefined,
        next: undefined,
      };

      if (index > 0) {
        navigation.previous = nodes[index - 1];
      }
      if (index < nodes.length - 1) {
        navigation.next = nodes[index + 1];
      }

      return navigation;
    },
  },

  methods: {
    async navigateTo(node: ReportNode) {
      const execute = async () => {
        if (this.context.nodes) {
          const path = SurveyNodeUtils.generatePath(node, this.context.nodes);
          if (this.context.surveyParticipation) {
            await this.$router.push({
              name: 'survey-report',
              params: {
                participantId: this.context.surveyParticipation?.id as any,
                path: path?.join('-') || '1',
              },
            });
          } else {
            await this.$router.push({
              name: 'survey-edit-preview',
              params: {
                id: this.context.survey?.id as any,
                path: path?.join('-') || '1',
              },
            });
          }
        }
      };

      if (this.dirty) {
        await this.$confirm(
          this.$i18n.t('validation.confirmation.navigation').toString(),
          execute
        );
      } else {
        await execute();
      }
    },
  },
});
